<template>
  <div>
    <AdvertisementGanttList v-if="advertisements.length"
      discovery
      :advertisements="advertisements"
      :my-chart-start="myChartStart"
      :my-chart-end="myChartEnd"
      :current-zoom="currentZoom"
      :zoom-in="zoomIn"
      @getMoreAds="$emit('getMoreAds')"
      @update:myChartStart="updateMyChartStart($event)"
      @update:myChartEnd="updateMyChartEnd($event)"
    />
    <SpyderEmptyState 
      v-else-if="!loadingAdvertisements"
      class="mt-24"
      :filters-applied="filtersApplied"
      :has-search-query="hasSearchQuery"
      @clearFilters="$emit('clearFilters')"
    />
  </div>
</template>

<script>
import AdvertisementGanttList from '../../advertisements/AdvertisementGanttList.vue'
import SpyderEmptyState from '../SpyderEmptyState.vue'

export default {
  name: 'TimelineBrandView',
  components: {
    AdvertisementGanttList,
    SpyderEmptyState
  },
  props: {
    advertisements: {
      type: Array,
      required: true
    },
    loadingAdvertisements: {
      type: Boolean,
      required: true
    },
    myChartStart: {
      type: String,
      required: true
    },
    myChartEnd: {
      type: String,
      required: true
    },
    currentZoom: {
      type: String,
      required: true
    },
    zoomIn: {
      type: Function,
      required: true
    },
    filtersApplied: {
      type: Boolean,
      default: false
    },
    hasSearchQuery: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateMyChartStart(value) {
      this.$emit('update:myChartStart', value)
    },
    updateMyChartEnd(value) {
      this.$emit('update:myChartEnd', value)
    }
  }
}
</script>

<style scoped></style>